import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../../Utils/toastContext";
import { useDispatch, useSelector } from "react-redux";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import AddressAutocomplete from "../../../Components/addressInput/address-input";
import { useNavigate, useParams } from "react-router-dom";
import LabelWithStatus from "../../../Components/onboarding/label-with-status";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
import CustomDropdownWithFetch from "../../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
} from "../../../Redux/store/onboardingFormSlice";
import ReviewPopup from "../../../Components/onboarding/review-popup";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";

const CorporateInfo = ({ setCurrentStep }) => {
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [accountType, setAccountType] = useState(1);
  const rejectedFields = useSelector(
    (state) => state.form.rejectedFieldsShareholder,
  );
  const [accountTypeData, setAccountTypeData] = useState([]);
  const [businessNatureData, setBusinessNatureData] = useState([]);
  const [businessActivityData, setBusinessActivityData] = useState([]);
  const [companyTypeData, setCompanyTypeData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [expectedAmountData, setExpectedAmountData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const userStatus = useSelector((state) => state.user.userStatus);
  const { shareholderId, userType, isShareholder } = useParams();

  const [fullName, setfullName] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [formerNames, setFormerNames] = useState({
    verification_id: null,
    value: [],
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [newFormerName, setFormerName] = useState("");
  const [DoI, setDoI] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedStateType, setPreselectedStateType] = useState({});
  const [preselectedAccountType, setpreselectedAccountType] = useState({
    value: 1,
    label: "Australian Domestic Company",
  });
  const [preselectedInevstmentAmount, setpreselectedInevstmentAmount] =
    useState({});
  const [toCurrency, setToCurrency] = useState({
    verification_id: null,
    value: {
      id: 2,
      name: "AUD",
      symbol: "$",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessNature, setBusinessNature] = useState({
    verification_id: null,
    value: {
      id: null,
      name: "",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [profilePayloadFile, setProfilePayloadFile] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [stockExchangeData, setStockExchangeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 233,
    label: "United States",
  });
  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: "Australia",
      risk_factor: "low",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [formationCountry, setFormationCountry] = useState({
    verification_id: null,
    value: {
      id: 233,
      name: "United States",
      risk_factor: "low",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [investmentAmount, setInvestmentAmount] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [investmentAmountText, setInvestmentAmountText] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
  });
  const [stateId, setStateId] = useState({
    verification_id: null,
    value: {
      id: null,
      name: "",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [abn, setAbn] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [acn, setAcn] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [taxId, setTaxId] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState("/avatar.svg");
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const containerRef = useRef(null);
  const [nameFromBirth, setNameFromBirth] = useState("yes");
  const [activity, setActivity] = useState({
    verification_id: null,
    value: {
      id: null,
      name: "",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [activityText, setActivityText] = useState("");
  const [otherActivity, setOtherActivity] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [companyTypeText, setCompanyTypeText] = useState("Proprietary Company");
  const [registeredAddress, setRegisteredAddress] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [registeredAddressApi, setRegisteredAddressApi] = useState("");

  const [principalAddressApi, setPrincipalAddressApi] = useState("");
  const [principalAddress, setPrincipalAddress] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [companySecretary, setCompanySecretary] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCountry, setRedCountry] = useState(null);
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);

  const [redRegCountry, setRegCountry] = useState(null);
  const [redRegCity, setRegCity] = useState(null);
  const [redRegState, setRegState] = useState(null);

  const [principalCountry, setPrincipalCountry] = useState(null);
  const [principalCity, setPrincipalCity] = useState(null);
  const [principalState, setPrincipalState] = useState(null);
  const [agentCountry, setAgentCountry] = useState(null);
  const [agentCity, setAgentCity] = useState(null);
  const [agentState, setAgentState] = useState(null);

  const [companyWebsite, setCompanyWebsite] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [transactionLevel, setTransactionLevel] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [source, setSource] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [foreignRegistered, setForeignRegistered] = useState({
    verification_id: null,
    value: true,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [EIN, setEIN] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const clientIdRedux = useSelector((state) => state.user.clientId);
  const [clientNo, setClientNo] = useState({
    verification_id: null,
    value: clientIdRedux,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [arbn, setArbn] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [agentName, setAgentName] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [agentAddress, setAgentAddress] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [agentAddressApi, setAgentAddressApi] = useState("");
  const [stockExchangeId, setStockExchangeId] = useState({
    verification_id: null,
    value: {
      id: null,
      name: "",
    },
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [stockRegistered, setStockRegistered] = useState({
    verification_id: null,
    value: true,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [companyRegistrationNumber, setCompanyRegistrationNumber] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [foreignAddress, setForeignAddress] = useState({
    verification_id: null,
    value: "",
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [apIAddress, setApIAddress] = useState("");

  const [preSelectedCompanyType, setPreSelectedCompanyType] = useState({
    value: 1,
    label: "Proprietary Company",
  });
  const [preselectedActivity, setPreselectedActivity] = useState({});
  const [preselectedBusinessNature, setPreselectedBusinessNature] = useState(
    {},
  );
  const fieldLabelMap = {
    country_of_formation_id: "Country of formation",
    company_logo_file: "Company Logo",
    company_full_name:
      accountType == 2
        ? "Full Name of the Company (as Registered by the Asic)"
        : "Full Name of the Company",
    former_trading_names: "All Other Business Name(s)",
    business_nature: "Business Nature",
    business_activities: "Describe the business activity",
    date_of_incorporation: "Company's Date of Incorporation",
    foreign_ein: "Employer Identification Number (EIN)",
    foreign_registration_number: "Company registration number",
    country_of_formation_address:
      "Address of the company in its country of formation",
    country_of_domicile_id: "Company’s Domicile Country",
    registered_office_address: "Address of the Company's Registered Office",
    principal_place_address:
      "Address of the Company's Principal place of business",
    state_or_territory_in_aus: "State or Territory in Australia",
    beneficial_ownership_with_caprock:
      "Beneficial ownership of the funds used by this account with Caprock",
    abn: "ABN",
    acn: "ACN",
    relevant_stock_exchange_id: "Relevant Stock Exchange",
    arbn: "ARBN",
    company_secretary_name: "The Name of the Company’s Secretary",
    companyWebsite: "Company Website",
    tax_id: "Tax Id",
    default_investment_currency_id: "Default Investment Currency",
    intended_transaction_behavior:
      "Nature and level of the intended transaction behaviour",
    source_of_funds_origin: "Source of the funds including its origin",
    expected_investment_amount: "Expected Investment Amount",
    local_agent_full_name: "Agent's Name",
    local_agent_address: "Agent's Address",
  };
  const handleSelectCompanyType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setCompanyTypeId(selectedOption.value);
    setCompanyTypeText(selectedOption.label);
  };
  const handleBack = () => {};

  const resetApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      userType == "trustee"
        ? `${BASE_URL}/v1/onboarding/trust/corporate-trustees/corporate-information/reset/${shareholderId}`
        : `${BASE_URL}/v1/onboarding/stakeholder/corporate/corporate-information/reset/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
        getDetailsWithVerification();
        if (userType == "trustee") {
          const responseStatus = await GetAPIcalls(
            `/v1/onboarding/trust/corporate-trustees/sections/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/trust/corporate-trustees/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          const responseStatus = await GetAPIcalls(
            `/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleSelectFormtionCountry = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setFormationCountry({
      ...formationCountry,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        risk_factor: selectedOption.risk_factor,
      },
    });
  };
  const handleSelectDomicileCountry = (selectedOption) => {
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        risk_factor: selectedOption.risk_factor,
      },
    });
  };
  const handleNameForeignRegistered = (e) => {
    const value = e.target.value === "true"; // convert string → boolean
    setForeignRegistered({
      ...foreignRegistered,
      value: value,
    });
  };

  const handleStockRegistered = (e) => {
    const value = e.target.value === "true"; // convert string → boolean
    setStockRegistered({
      ...stockRegistered,
      value: value,
    });
  };
  const handleSelectActivity = (selectedOption) => {
    setActivity({
      ...activity,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
    setOtherActivity({
      verification_id: null,
      value: "",
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const isEmpty = (v) => !v;
  const hasId = (v) => v?.id;
  const isTrue = (v) => v === true;

  const checkFields = () => {
    const isLocal = accountType == 1;
    const isForeign = accountType != 1;
    const isPublicCompany = accountType == 3;

    const validations = [
      // ---------- Addresses ----------
      {
        when:
          isForeign &&
          isTrue(foreignRegistered.value) &&
          (!foreignAddress.value || !redCountry),
        msg: "Please add valid address of the company in its country of formation",
      },
      {
        when: !principalAddress.value || !principalCountry,
        msg: "Please enter valid address of the company's principal place of business",
      },
      {
        when:
          isForeign &&
          agentName.value &&
          (!agentAddress.value || !agentCountry),
        msg: "Please enter valid address of the agent",
      },
      {
        when: !registeredAddress.value || !redRegCountry,
        msg: "Please enter valid address of the company's registered office",
      },

      // ---------- Company Info ----------
      {
        when: !fullName.value,
        msg: "Please enter full name of the company",
      },
      {
        when: !DoI.value,
        msg: "Please select valid date of incorporation",
      },
      {
        when: isForeign && !hasId(formationCountry.value),
        msg: "Please select country of formation",
      },

      // ---------- Identifiers ----------
      {
        when: isLocal && !stateId.value,
        msg: "Please select state",
      },
      {
        when: isLocal && !abn.value,
        msg: "Please enter a valid ABN",
      },
      {
        when: isLocal && !acn.value,
        msg: "Please enter a valid ACN",
      },
      {
        when: isForeign && !arbn.value,
        msg: "Please enter a valid ARBN",
      },
      {
        when: isForeign && isTrue(foreignRegistered.value) && !EIN.value,
        msg: "Please enter employer identification number (EIN)",
      },
      {
        when:
          isForeign &&
          isTrue(foreignRegistered.value) &&
          !companyRegistrationNumber.value,
        msg: "Please enter company registration number",
      },
      {
        when: isForeign && formationCountry.value?.id === 233 && !taxId.value,
        msg: "Please enter valid tax id",
      },

      // ---------- Business Details ----------
      {
        when: !hasId(businessNature.value),
        msg: "Please select a business nature",
      },
      {
        when: !hasId(activity.value),
        msg: "Please select a business activity",
      },
      {
        when: !companySecretary.value,
        msg: "Please enter the name of the company’s secretary",
      },
      {
        when: !companyWebsite.value,
        msg: "Please enter the url of the company’s website",
      },

      // ---------- Public Company ----------
      {
        when: isPublicCompany && !countryCode.value,
        msg: "Please select company’s domicile country",
      },
      {
        when:
          isPublicCompany &&
          isTrue(stockRegistered.value) &&
          !stockExchangeId.value,
        msg: "Please select the relevant stock exchange",
      },

      // ---------- Financials ----------
      {
        when: !hasId(toCurrency.value),
        msg: "Please select a valid currency",
      },
      {
        when: !investmentAmountText.value,
        msg: "Please select expected investment amount",
      },
      {
        when: !transactionLevel.value,
        msg: "Please enter transaction behaviour",
      },
      {
        when: !source.value,
        msg: "Please enter a valid source of the funds",
      },

      // ---------- Uploads ----------
      {
        when: !profilePayloadFile.value,
        msg: "Please upload company logo",
      },
    ];

    const error = validations.find((v) => v.when);
    if (error) {
      showToast(error.msg, "error");
      return true;
    }

    return false;
  };

  const handleContinue = async (isFinal) => {
    if (!checkFields()) {
      setLoading(true);
      handlesave(isFinal);
    }
  };

  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        foreignAddress.value.country &&
          foreignAddress.value.country.name &&
          foreignAddress.value.country.name !== ""
          ? foreignAddress.value.country.name
          : foreignAddress.value.country,
        foreignAddress.value.state &&
          foreignAddress.value.state.name &&
          foreignAddress.value.state.name !== ""
          ? foreignAddress.value.state.name
          : foreignAddress.value.state,
        foreignAddress.value.city &&
          foreignAddress.value.city.name &&
          foreignAddress.value.city.name !== ""
          ? foreignAddress.value.city.name
          : foreignAddress.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllLocationDetailsReg = async () => {
    try {
      const response = await getLocation(
        registeredAddress.value.country &&
          registeredAddress.value.country.name &&
          registeredAddress.value.country.name !== ""
          ? registeredAddress.value.country.name
          : registeredAddress.value.country,
        registeredAddress.value.state &&
          registeredAddress.value.state.name &&
          registeredAddress.value.state.name !== ""
          ? registeredAddress.value.state.name
          : registeredAddress.value.state,
        registeredAddress.value.city &&
          registeredAddress.value.city.name &&
          registeredAddress.value.city.name !== ""
          ? registeredAddress.value.city.name
          : registeredAddress.value.city,
      );
      setRegCountry(response.country_id);
      setRegState(response.state_id);
      setRegCity(response.city_id);
    } catch (err) {
      setRegCountry(null);
      setRegState(null);
      setRegCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllLocationDetailsPrincipal = async () => {
    try {
      const response = await getLocation(
        principalAddress.value.country &&
          principalAddress.value.country.name &&
          principalAddress.value.country.name !== ""
          ? principalAddress.value.country.name
          : principalAddress.value.country,
        principalAddress.value.state &&
          principalAddress.value.state.name &&
          principalAddress.value.state.name !== ""
          ? principalAddress.value.state.name
          : principalAddress.value.state,
        principalAddress.value.city &&
          principalAddress.value.city.name &&
          principalAddress.value.city.name !== ""
          ? principalAddress.value.city.name
          : principalAddress.value.city,
      );
      setPrincipalCountry(response.country_id);
      setPrincipalState(response.state_id);
      setPrincipalCity(response.city_id);
    } catch (err) {
      setPrincipalCountry(null);
      setPrincipalState(null);
      setPrincipalCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllLocationDetailsAgent = async () => {
    try {
      const response = await getLocation(
        agentAddress.value.country &&
          agentAddress.value.country.name &&
          agentAddress.value.country.name !== ""
          ? agentAddress.value.country.name
          : agentAddress.value.country,
        agentAddress.value.state &&
          agentAddress.value.state.name &&
          agentAddress.value.state.name !== ""
          ? agentAddress.value.state.name
          : agentAddress.value.state,
        agentAddress.value.city &&
          agentAddress.value.city.name &&
          agentAddress.value.city.name !== ""
          ? agentAddress.value.city.name
          : agentAddress.value.city,
      );
      setAgentCountry(response.country_id);
      setAgentState(response.state_id);
      setAgentCity(response.city_id);
    } catch (err) {
      setAgentCountry(null);
      setAgentState(null);
      setAgentCity(null);
      showToast(err.message, "error");
    } finally {
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/countries?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
          risk_factor: item.risk_factor,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const getEnum = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/corporate/corporate-information/enums`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.company_types.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setAccountTypeData(AccountData);
        setpreselectedAccountType(AccountData[0]);
        setAccountType(AccountData[0].value);
        const buninessNatureData = [];
        response.data.business_natures.forEach((profile) => {
          buninessNatureData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setBusinessNatureData(buninessNatureData);

        const buninessActivityData = [];
        response.data.business_activities.forEach((profile) => {
          buninessActivityData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setBusinessActivityData(buninessActivityData);

        const companyData = [];
        response.data.registered_by_ASIC_as.forEach((profile) => {
          companyData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setCompanyTypeData(companyData);
        setPreSelectedCompanyType(companyData[0]);

        const statelistData = [];
        response.data.states_or_territories_in_AUS.forEach((profile) => {
          statelistData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setStateData(statelistData);

        const expectedAmountData = [];
        response.data.expected_investment_amounts.forEach((profile) => {
          expectedAmountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setExpectedAmountData(expectedAmountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountTypeData([]);
          setpreselectedAccountType({});
          setAccountType(null);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setAccountTypeData([]);
      setpreselectedAccountType({});
      setAccountType(null);
    } finally {
    }
  };
  const getstocks = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/corporate/corporate-information/stock-exchanges/${formationCountry.value.id}`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setStockExchangeData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setStockExchangeData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setStockExchangeData([]);
    } finally {
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            symbol: profile.symbol,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        userType == "trustee"
          ? `/v1/onboarding/trust/corporate-trustees/corporate-information/preview/verification/${shareholderId}`
          : `/v1/onboarding/stakeholder/corporate/corporate-information/preview/${shareholderId}/verifications`,
      );

      if (response.status == 200) {
        if (response.data) {
          setAccountType(response.data.corporate_type.value.id);
          setpreselectedAccountType({
            value: response.data.corporate_type.value.id,
            label: response.data.corporate_type.value.name,
          });
          setProfilePayloadFile(response.data.company_logo_url);
          setPreview(
            response.data.company_logo_url.value.presigned_url == ""
              ? "/avatar.svg"
              : response.data.company_logo_url.value.presigned_url,
          );
          setfullName(response.data.company_full_name);
          setFormerNames(response.data.former_trading_names);
          setDoI(response.data.date_of_incorporation);
          setCompanyTypeId(response.data.registered_by_asic_as.value.id);
          setCompanyTypeText(response.data.registered_by_asic_as.value.name);
          setPreSelectedCompanyType({
            value: response.data.registered_by_asic_as.value.id,
            label: response.data.registered_by_asic_as.value.name,
          });
          setSource(response.data.source_of_funds_origin);
          setBusinessNature(response.data.business_nature);
          setPreselectedBusinessNature({
            value: response.data.business_nature.value.id,
            label: response.data.business_nature.value.name,
          });
          setActivity(response.data.business_activities);
          setPreselectedActivity({
            value: response.data.business_activities.value.id,
            label: response.data.business_activities.value.name,
          });
          setApIAddress(response.data.country_of_formation_address.value);
          setForeignAddress(response.data.country_of_formation_address);
          setRegisteredAddressApi(
            response.data.registered_office_address.value,
          );
          setRegisteredAddress(response.data.registered_office_address);
          setPrincipalAddressApi(response.data.principal_place_address.value);
          setPrincipalAddress(response.data.principal_place_address);
          setArbn(
            response.data.arbn
              ? response.data.arbn
              : {
                  verification_id: null,
                  value: "",
                  status: "pending",
                  rejection_reason: null,
                  rejection_comment: null,
                  rejection_timestamp: null,
                  rejected_by: null,
                  comments: [],
                },
          );
          setCompanySecretary(
            response.data.company_secretary_name
              ? response.data.company_secretary_name
              : {
                  verification_id: null,
                  value: "",
                  status: "pending",
                  rejection_reason: null,
                  rejection_comment: null,
                  rejection_timestamp: null,
                  rejected_by: null,
                  comments: [],
                },
          );
          setCompanyWebsite(
            response.data.company_website
              ? response.data.company_website
              : {
                  verification_id: null,
                  value: "",
                  status: "pending",
                  rejection_reason: null,
                  rejection_comment: null,
                  rejection_timestamp: null,
                  rejected_by: null,
                  comments: [],
                },
          );
          setToCurrency(response.data.default_investment_currency_id);
          setpreselectedCurrency({
            value: response.data.default_investment_currency_id.value.id,
            label: response.data.default_investment_currency_id.value.name,
          });
          setTransactionLevel(
            response.data.intended_transaction_behavior
              ? response.data.intended_transaction_behavior
              : {
                  verification_id: null,
                  value: "",
                  status: "pending",
                  rejection_reason: null,
                  rejection_comment: null,
                  rejection_timestamp: null,
                  rejected_by: null,
                  comments: [],
                },
          );
          // setStockRegistered(response.data.)
          setInvestmentAmountText(response.data.expected_investment_amount);
          let investmentAmount = expectedAmountData.filter(
            (item) =>
              item.label == response.data.expected_investment_amount.value,
          );
          setpreselectedInevstmentAmount({
            value: investmentAmount[0].value,
            label: response.data.expected_investment_amount.value,
          });
          if (response.data.corporate_type.value.id != 1) {
            if (
              response.data.country_of_formation.value &&
              response.data.country_of_formation.value.id
            ) {
              setFormationCountry(response.data.country_of_formation);
              setpreselectedCountryCode({
                value: response.data.country_of_formation.value.id,
                label: response.data.country_of_formation.value.name,
              });
              if (response.data.country_of_formation.value.id == 233) {
                setTaxId(response.data.us_tax_id);
              }
            }
            setForeignRegistered(response.data.is_registered_foreign_body);
            setEIN(response.data.foreign_ein);
            setCompanyRegistrationNumber(
              response.data.foreign_registration_number,
            );
            setAgentName(response.data.local_agent_full_name);
            setAgentAddress(response.data.local_agent_address);
            setAgentAddressApi(response.data.local_agent_address.value);
          }
          if (response.data.corporate_type.value.id == 1) {
            setStateId(response.data.state_or_territory_in_aus);
            setPreselectedStateType({
              value: response.data.state_or_territory_in_aus.value.id,
              label: response.data.state_or_territory_in_aus.value.name,
            });
            setAbn(response.data.abn);
            setAcn(response.data.acn);
          }
          if (response.data.corporate_type.value.id == 3) {
            setCountryCode(
              response.data.country_of_domicile
                ? response.data.country_of_domicile
                : {
                    verification_id: null,
                    value: "",
                    status: "pending",
                    rejection_reason: null,
                    rejection_comment: null,
                    rejection_timestamp: null,
                    rejected_by: null,
                    comments: [],
                  },
            );
            //stock exchange
          }
        } else {
          setAccountType(1);
          setpreselectedAccountType({
            value: 1,
            label: "Australian Domestic Company",
          });
          setProfilePayloadFile({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreview("/avatar.svg");
          setfullName({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFormerNames({
            verification_id: null,
            value: [],
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setDoI({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCompanyTypeId(1);
          setCompanyTypeText("Proprietary Company");
          setPreSelectedCompanyType({
            value: 1,
            label: "Proprietary Company",
          });
          setSource({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setBusinessNature({
            verification_id: null,
            value: {
              id: null,
              name: "",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreselectedBusinessNature({});
          setActivity({
            verification_id: null,
            value: {
              id: null,
              name: "",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreselectedActivity({});
          setClientNo({
            verification_id: null,
            value: clientIdRedux,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setApIAddress("");
          setForeignAddress({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setRegisteredAddressApi("");
          setRegisteredAddress({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPrincipalAddressApi("");
          setPrincipalAddress({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setArbn({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCompanySecretary({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCompanyWebsite({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setToCurrency({
            verification_id: null,
            value: {
              id: 2,
              name: "AUD",
              symbol: "$",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCurrency({
            value: 2,
            label: "AUD",
          });
          setTransactionLevel({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setInvestmentAmountText({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
          });
          setpreselectedInevstmentAmount({});
          setFormationCountry({
            verification_id: null,
            value: {
              id: 233,
              name: "United States",
              risk_factor: "low",
            },
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCountryCode({
            value: 233,
            label: "United States",
          });
          setTaxId({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setForeignRegistered({
            verification_id: null,
            value: true,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setEIN({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCompanyRegistrationNumber({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAgentName({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAgentAddress({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAgentAddressApi({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setStateId({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreselectedStateType({});
          setAbn({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAcn({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCountryCode({
            verification_id: null,
            value: "",
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getEnum();
    getAllCurrency();
  }, []);
  useEffect(() => {
    if (stockRegistered && formationCountry.value.id != null) getstocks();
  }, [stockRegistered, formationCountry]);
  useEffect(() => {
    if (
      (foreignAddress.value && foreignAddress.value.country) ||
      (foreignAddress.value && foreignAddress.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [foreignAddress]);

  useEffect(() => {
    if (
      (registeredAddress.value && registeredAddress.value.country) ||
      (registeredAddress.value && registeredAddress.value.country.name)
    ) {
      getAllLocationDetailsReg();
    }
  }, [registeredAddress]);

  useEffect(() => {
    if (
      (principalAddress.value && principalAddress.value.country) ||
      (principalAddress.value && principalAddress.value.country.name)
    ) {
      getAllLocationDetailsPrincipal();
    }
  }, [principalAddress]);

  useEffect(() => {
    if (
      (agentAddress.value && agentAddress.value.country) ||
      (agentAddress.value && agentAddress.value.country.name)
    ) {
      getAllLocationDetailsAgent();
    }
  }, [agentAddress]);
  useEffect(() => {
    if (
      expectedAmountData.length > 0 &&
      stepStatus.length > 0 &&
      stepStatus[0].status != "DRAFT"
    ) {
      getDetailsWithVerification();
    }
  }, [expectedAmountData, stepStatus]);

  const handleSelectBusinessNature = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setBusinessNature({
      ...businessNature,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleSelectStateData = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setStateId({
      ...stateId,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleSelectStockExchange = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setStockExchangeId({
      ...stockExchangeId,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const handleSelectAccountType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setAccountType(selectedOption.value);
  };
  const handleSelectInvestmentAmount = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setInvestmentAmountText({
      ...investmentAmountText,
      value: selectedOption.label,
    });
  };

  const handleAddFormerName = (e) => {
    if (e.key === "Enter" && newFormerName.trim() !== "") {
      setFormerNames((prev) => ({
        ...prev,
        value: [...prev.value, newFormerName.trim()],
      }));
      setFormerName(""); // clear input
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames((prev) => ({
      ...prev,
      value: prev.value.filter((_, index) => index !== indexToRemove),
    }));
  };
  const handleSelectToCurrency = (selectedOption) => {
    setToCurrency({
      ...toCurrency,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await UploadCSVApi(file);
        if (response.status == "201") {
          toastMessage = {
            message: "Logo uploaded successfully",
            type: "success",
          };
          const imageUrl = URL.createObjectURL(file);
          setPreview(imageUrl);
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
        }
      } catch (err) {
        setPreview("/avatar.svg");
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = "";
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      let payloadAddress = {};
      if (foreignRegistered.value == true) {
        if (apIAddress != null) {
          payloadAddress = {
            address_line_1:
              apIAddress.address_line_1 == null
                ? apIAddress.google_address
                : apIAddress.address_line_1,
            address_line_2:
              apIAddress.address_line_2 == null
                ? null
                : apIAddress.address_line_2,
            city_id: apIAddress.city != null ? apIAddress.city.id : null,
            state_id: apIAddress.city != null ? apIAddress.city.state_id : null,
            country_id: redCountry,
            zip_code: apIAddress.zip_code,
            google_address: apIAddress.google_address,
          };
        } else {
          payloadAddress = {
            address_line_1:
              foreignAddress.value.street == ""
                ? foreignAddress.value.full
                : foreignAddress.value.street,
            address_line_2: foreignAddress.value.route,
            city_id: redCity,
            state_id: redState,
            country_id: redCountry,
            zip_code: foreignAddress.value.zip,
            google_address: foreignAddress.value.full,
          };
        }
        if (payloadAddress.city_id === null) {
          showToast(
            "Please add valid address of the company in its country of formation.",
            "error",
          );
          return; // Stop execution if city_id is missing
        }
      }

      const response = await submitApplicationAPI(isFinal, payloadAddress);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(2);
          toastMessage = {
            message: response.message,
            type: "success",
          };
          if (userType == "trustee") {
            const responseStatus = await GetAPIcalls(
              `/v1/onboarding/trust/corporate-trustees/sections/${shareholderId}`,
            );
            if (responseStatus.status == 200) {
              if (responseStatus.data.length > 0) {
                dispatch(setStepStatusShareholder(responseStatus.data));
              }
            }
            const responseRejected = await GetAPIcalls(
              `/v1/onboarding/trust/corporate-trustees/rejected-fields/${shareholderId}`,
            );
            if (responseRejected.status == 200) {
              dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
            }
          } else {
            const responseStatus = await GetAPIcalls(
              `/v1/onboarding/stakeholder/status/${shareholderId}`,
            );
            if (responseStatus.status == 200) {
              if (responseStatus.data.length > 0) {
                dispatch(setStepStatusShareholder(responseStatus.data));
              }
            }
            const responseRejected = await GetAPIcalls(
              `/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
            );
            if (responseRejected.status == 200) {
              dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
            }
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const submitApplicationAPI = async (isFinal, payloadAddress) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording =
      stepStatus.length > 0 && stepStatus[0].status == "DRAFT" ? true : false;
    let apiUrl = isOnbaording
      ? userType == "trustee"
        ? `${BASE_URL}/v1/onboarding/trust/corporate-trustees/corporate-information/submit/${shareholderId}`
        : `${BASE_URL}/v1/onboarding/stakeholder/corporate/corporate-information/submit/${shareholderId}`
      : userType == "trustee"
        ? `${BASE_URL}/v1/onboarding/trust/corporate-trustees/corporate-information/update/${shareholderId}`
        : `${BASE_URL}/v1/onboarding/stakeholder/corporate/corporate-information/update/${shareholderId}`;
    let payloadRegAddress = {};
    if (registeredAddressApi != null) {
      payloadRegAddress = {
        address_line_1:
          registeredAddressApi.address_line_1 == null
            ? registeredAddressApi.google_address
            : registeredAddressApi.address_line_1,
        address_line_2:
          registeredAddressApi.address_line_2 == null
            ? null
            : registeredAddressApi.address_line_2,
        city_id:
          registeredAddressApi.city != null
            ? registeredAddressApi.city.id
            : null,
        state_id:
          registeredAddressApi.city != null
            ? registeredAddressApi.city.state_id
            : null,
        country_id: redRegCountry,
        zip_code: registeredAddressApi.zip_code,
        google_address: registeredAddressApi.google_address,
      };
    } else {
      payloadRegAddress = {
        address_line_1:
          registeredAddress.value.street == ""
            ? registeredAddress.value.full
            : registeredAddress.value.street,
        address_line_2: registeredAddress.value.route,
        city_id: redRegCity,
        state_id: redRegState,
        country_id: redRegCountry,
        zip_code: registeredAddress.value.zip,
        google_address: registeredAddress.value.full,
      };
    }
    if (payloadRegAddress.city_id === null) {
      showToast(
        "Please enter valid address of the company's registered office",
        "error",
      );
      return; // Stop execution if city_id is missing
    }
    let payloadPrincipalAddress = {};
    if (registeredAddressApi != null) {
      payloadPrincipalAddress = {
        address_line_1:
          principalAddressApi.address_line_1 == null
            ? principalAddressApi.google_address
            : principalAddressApi.address_line_1,
        address_line_2:
          principalAddressApi.address_line_2 == null
            ? null
            : principalAddressApi.address_line_2,
        city_id:
          principalAddressApi.city != null ? principalAddressApi.city.id : null,
        state_id:
          principalAddressApi.city != null
            ? principalAddressApi.city.state_id
            : null,
        country_id: principalCountry,
        zip_code: principalAddressApi.zip_code,
        google_address: principalAddressApi.google_address,
      };
    } else {
      payloadPrincipalAddress = {
        address_line_1:
          principalAddress.value.street == ""
            ? principalAddress.value.full
            : principalAddress.value.street,
        address_line_2: principalAddress.value.route,
        city_id: principalCity,
        state_id: principalState,
        country_id: principalCountry,
        zip_code: principalAddress.value.zip,
        google_address: principalAddress.value.full,
      };
    }
    if (payloadPrincipalAddress.city_id === null) {
      showToast(
        "Please enter valid address of the company's principal place of business.",
        "error",
      );
      return; // Stop execution if city_id is missing
    }

    let payloadAgentAddress = {};
    if (agentName.value) {
      if (agentAddressApi != null) {
        payloadAgentAddress = {
          address_line_1:
            agentAddressApi.address_line_1 == null
              ? agentAddressApi.google_address
              : agentAddressApi.address_line_1,
          address_line_2:
            agentAddressApi.address_line_2 == null
              ? null
              : agentAddressApi.address_line_2,
          city_id:
            agentAddressApi.city != null ? agentAddressApi.city.id : null,
          state_id:
            agentAddressApi.city != null ? agentAddressApi.city.state_id : null,
          country_id: agentCountry,
          zip_code: agentAddressApi.zip_code,
          google_address: agentAddressApi.google_address,
        };
      } else {
        payloadAgentAddress = {
          address_line_1:
            agentAddress.value.street == ""
              ? agentAddress.value.full
              : agentAddress.value.street,
          address_line_2: agentAddress.value.route,
          city_id: agentCity,
          state_id: agentState,
          country_id: agentCountry,
          zip_code: agentAddress.value.zip,
          google_address: agentAddress.value.full,
        };
      }
      if (payloadAgentAddress.city_id === null) {
        showToast("Please enter valid address of the agent.", "error");
        return; // Stop execution if city_id is missing
      }
    }
    let bodyData = {};
    if (accountType == 1) {
      bodyData = {
        corporate_type: accountType,
        business_nature: businessNature.value.id,
        company_full_name: fullName.value,
        business_activities: activity.value.id,
        company_logo_file: {
          file_id: profilePayloadFile.value.file_id,
          file_name: profilePayloadFile.value.file_name,
        },
        date_of_incorporation: DoI.value,
        former_trading_names: formerNames.value,
        company_website: companyWebsite.value,
        expected_investment_amount: investmentAmountText.value,
        default_investment_currency_id: toCurrency.value.id,
        source_of_funds_origin: source.value,
        intended_transaction_behavior: transactionLevel.value,
        registered_by_asic_as: companyTypeId,
        registered_office_address: payloadRegAddress,
        company_secretary_name: companySecretary.value,
        principal_place_address: payloadPrincipalAddress,
        state_or_territory_in_aus: stateId.value.id,
        abn: abn.value,
        acn: acn.value,
        client_id: clientNo.value,
        is_submitted: isFinal,
      };
    } else {
      bodyData = {
        corporate_type: accountType,
        business_nature: businessNature.value.id,
        company_full_name: fullName.value,
        business_activities: activity.value.id,
        company_logo_file: {
          file_id: profilePayloadFile.value.file_id,
          file_name: profilePayloadFile.value.file_name,
        },
        date_of_incorporation: DoI.value,
        former_trading_names: formerNames.value,
        company_website: companyWebsite.value,
        expected_investment_amount: investmentAmountText.value,
        default_investment_currency_id: toCurrency.value.id,
        source_of_funds_origin: source.value,
        intended_transaction_behavior: transactionLevel.value,
        is_registered_foreign_body: foreignRegistered.value,
        foreign_ein: EIN.value,
        foreign_registration_number: companyRegistrationNumber.value,
        country_of_formation_address: payloadAddress,
        registered_by_asic_as: companyTypeId,
        registered_office_address: payloadRegAddress,
        company_secretary_name: companySecretary.value,
        principal_place_address: payloadPrincipalAddress,
        arbn: arbn.value,
        local_agent_full_name: agentName.value,
        local_agent_address: payloadAgentAddress,
        country_of_domicile_id: countryCode.value.id,
        country_of_formation_id: formationCountry.value.id,
        is_listed_on_comparable_exchange: stockRegistered.value,
        relevant_stock_exchange_id: stockExchangeId.value.id,
        us_tax_id: taxId.value,
        client_id: clientNo.value,
        is_submitted: isFinal,
      };
    }

    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? "POST" : "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {formationCountry.value &&
          formationCountry.value.risk_factor == "high" && (
            <div className="mb-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
              <img src="/tick-error.svg" alt="Info" className="w-5 h-5 mr-2" />
              <span>
                It looks like we’re
                <strong> not able to accept applications</strong> from this
                country at the moment.{" "}
              </span>
            </div>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == "IN_REVIEW" ||
            stepStatus[0].status == "COMPLETED") && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{" "}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{" "}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[0].status == "APPROVED" && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.CORPORATE_INFORMATION?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.CORPORATE_INFORMATION.rejected_fields.length === 1
                ? "The following field requires correction:"
                : "The following fields require correction:"}{" "}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.CORPORATE_INFORMATION.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, " ")}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/briefcase.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Corporate Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      Select Your Company Category
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={accountTypeData}
                  onSelect={handleSelectAccountType}
                  preselectedValue={preselectedAccountType}
                />
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col md:px-4">
              {accountType != 1 && (
                <>
                  <div className="">
                    <CustomDropdownWithFetch
                      label={
                        <>
                          {fieldLabelMap.country_of_formation_id}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      search={true}
                      preselectedValue={preselectedCountryCode}
                      onSelect={handleSelectFormtionCountry}
                      colorLabel=""
                      fetchOptions={getCountries} // <-- pass fetch function, not options
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          {formationCountry.value &&
            formationCountry.value.risk_factor != "high" && (
              <div className="bg-white">
                <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  {/* Profile Picture Section */}
                  <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    <LabelWithStatus
                      id="companyLogo"
                      label={fieldLabelMap.company_logo_file}
                      required={true}
                      fieldData={profilePayloadFile}
                      handleStatusClick={handleStatusClick}
                    />
                    <div className="mt-1">
                      <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        PNG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        JPEG
                      </span>
                      <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                        &#60; 10 MB
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-16 h-16 flex items-center justify-center">
                        <img
                          src={preview}
                          alt="Avatar"
                          className={`${
                            profilePayloadFile.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          } w-14 h-14 rounded-full`}
                        />
                      </div>
                      <div className="flex flex-col space-y-1">
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                        />
                        <button
                          onClick={handleUploadClick}
                          disabled={preview.status == "approved"}
                          className={`${
                            preview.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border-black border-2"
                          }
                          bg-white text-black text-xs px-3 py-1 rounded-full`}
                        >
                          Upload from Device
                        </button>
                      </div>
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.company_full_name}
                        required={true}
                        fieldData={fullName}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="fullName"
                        name="firstName"
                        type="text"
                        value={fullName.value}
                        placeholder="Your Full Name"
                        disabled={fullName.status == "approved"}
                        className={`${
                          fullName.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setfullName({
                            ...fullName,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.former_trading_names}
                        required={true}
                        fieldData={formerNames}
                        handleStatusClick={handleStatusClick}
                      />
                      <div
                        className={`${
                          formerNames.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border-gray-300"
                        } mt-1 border rounded-md  p-2 flex flex-wrap gap-2`}
                      >
                        {" "}
                        {formerNames.value && formerNames.value.length > 0 && (
                          <>
                            {" "}
                            {formerNames.value.map((formerName, index) => (
                              <div
                                key={index}
                                className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                              >
                                <span>{formerName}</span>
                                <button
                                  type="button"
                                  onClick={() => handleRemoveFormerName(index)}
                                  className="ml-2 text-gray-700 hover:text-gray-700"
                                >
                                  &times;
                                </button>
                              </div>
                            ))}
                          </>
                        )}
                        <input
                          type="text"
                          value={newFormerName}
                          onChange={(e) => setFormerName(e.target.value)}
                          onKeyDown={handleAddFormerName}
                          placeholder="Add name"
                          disabled={formerNames.status == "approved"}
                          className="border-none focus:outline-none flex-grow text-sm"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                    <div className="">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.business_nature}
                        required={true}
                        fieldData={businessNature}
                        handleStatusClick={handleStatusClick}
                      />
                      <Dropdown
                        label=""
                        options={businessNatureData}
                        onSelect={handleSelectBusinessNature}
                        disabled={businessNature.status == "approved"}
                        preselectedValue={preselectedBusinessNature}
                        parentClass={
                          businessNature.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        }
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.business_activities}
                        required={true}
                        fieldData={activity}
                        handleStatusClick={handleStatusClick}
                      />
                      <Dropdown
                        label=""
                        options={businessActivityData}
                        onSelect={handleSelectActivity}
                        disabled={activity.status == "approved"}
                        preselectedValue={preselectedActivity}
                        parentClass={
                          activity.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        }
                      />
                    </div>
                    {activity == 6 && (
                      <div className="mt-4">
                        <LabelWithStatus
                          id="companyLogo"
                          label="Please mention business activity"
                          required={true}
                          fieldData={otherActivity}
                          handleStatusClick={handleStatusClick}
                        />
                        <input
                          id="others"
                          name="others"
                          type="text"
                          value={otherActivity}
                          placeholder="Other activity"
                          disabled={otherActivity.status == "approved"}
                          className={`${
                            otherActivity.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                          onChange={(e) =>
                            setOtherActivity((e) =>
                              setOtherActivity({
                                ...otherActivity,
                                value: e.target.value,
                              }),
                            )
                          }
                        />
                      </div>
                    )}
                    <div>
                      <LabelWithStatus
                        id="DoI"
                        label={fieldLabelMap.date_of_incorporation}
                        required={true}
                        fieldData={DoI}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        type="date"
                        value={DoI.value}
                        disabled={DoI.status == "approved"}
                        onChange={(e) =>
                          setDoI({
                            ...DoI,
                            value: e.target.value,
                          })
                        }
                        className={`${
                          DoI.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border-gray-300"
                        } block w-full p-2 text-black font-medium border rounded-md text-md`}
                      />
                    </div>
                  </div>
                  <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                    {accountType != 1 && (
                      <>
                        <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                          <label
                            htmlFor="investmentType"
                            className="block whitespace-normal break-words text-sm text-labelColour"
                          >
                            Is the company registered by the relevant foreign
                            registration body?
                            <span className="text-red-500">*</span>
                          </label>

                          {/* Radio Buttons */}
                          <div className="flex items-center gap-4">
                            <label className="flex items-center text-sm text-black">
                              <input
                                type="radio"
                                name="foreignRegistered"
                                value={true}
                                disabled={
                                  foreignRegistered.status == "approved"
                                }
                                checked={foreignRegistered.value === true}
                                onChange={handleNameForeignRegistered}
                                className={`${
                                  foreignRegistered.status == "rejected"
                                    ? "border-[#FF5050] border-2"
                                    : "border-gray-300"
                                } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                              />
                              <span className="ml-2">Yes</span>
                            </label>

                            <label className="flex items-center text-sm text-black">
                              <input
                                type="radio"
                                name="foreignRegistered"
                                value={false}
                                disabled={
                                  foreignRegistered.status == "approved"
                                }
                                checked={foreignRegistered.value === false}
                                onChange={handleNameForeignRegistered}
                                className={`${
                                  foreignRegistered.status == "rejected"
                                    ? "border-[#FF5050] border-2"
                                    : "border-gray-300"
                                } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                              />
                              <span className="ml-2">No</span>
                            </label>
                          </div>
                          {!foreignRegistered.value && (
                            <label
                              htmlFor="confirmpassword"
                              className="block whitespace-normal break-words mt-1 flex items-center font-normal text-xs text-[#FF5050]"
                            >
                              <img
                                src="/danger.svg"
                                alt="alert Icon"
                                className="h-4 w-4 mr-2"
                              />
                              Please select "Yes" and enter your tax information
                              to continue your application.{" "}
                            </label>
                          )}
                        </div>
                        {foreignRegistered.value && (
                          <>
                            <div className="mt-4">
                              <LabelWithStatus
                                id="EIN"
                                label={fieldLabelMap.foreign_ein}
                                required={false}
                                fieldData={EIN}
                                handleStatusClick={handleStatusClick}
                              />
                              <input
                                id="EIN"
                                name="EIN"
                                type="text"
                                value={EIN.value}
                                disabled={EIN.status == "approved"}
                                placeholder="EIN"
                                className={`${
                                  EIN.status == "rejected"
                                    ? "border-[#FF5050] border-2"
                                    : ""
                                } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                                onChange={(e) =>
                                  setEIN({
                                    ...EIN,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </div>
                            <div className="mt-4">
                              <LabelWithStatus
                                id="CompanyRegistrationNumber"
                                label={
                                  fieldLabelMap.foreign_registration_number
                                }
                                required={true}
                                fieldData={companyRegistrationNumber}
                                handleStatusClick={handleStatusClick}
                              />
                              <input
                                id="companyRegistrationNumber"
                                name="companyRegistrationNumber"
                                type="text"
                                value={companyRegistrationNumber.value}
                                disabled={
                                  companyRegistrationNumber.status == "approved"
                                }
                                placeholder="Your Full Name"
                                className={`${
                                  companyRegistrationNumber.status == "rejected"
                                    ? "border-[#FF5050] border-2"
                                    : ""
                                } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                                onChange={(e) =>
                                  setCompanyRegistrationNumber({
                                    ...companyRegistrationNumber,
                                    value: e.target.value,
                                  })
                                }
                              />
                            </div>
                            <div className="mt-4">
                              <LabelWithStatus
                                id="foreignAddress"
                                label="The address of the company in its country of
                            formation, incorporation or registration as
                            registered by the relevant foreign registration body"
                                required={true}
                                fieldData={foreignAddress}
                                handleStatusClick={handleStatusClick}
                              />
                              <AddressAutocomplete
                                disabled={foreignAddress.status == "approved"}
                                value={
                                  foreignAddress?.value?.full ||
                                  apIAddress?.google_address ||
                                  ""
                                }
                                className={
                                  foreignAddress.status == "rejected"
                                    ? "border-[#FF5050] border-2 w-full"
                                    : "w-full"
                                }
                                onSelect={(addr) => {
                                  setApIAddress(null);
                                  setForeignAddress({
                                    ...foreignAddress,
                                    value: addr,
                                  });
                                }}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
        {formationCountry.value &&
          formationCountry.value.risk_factor != "high" &&
          (accountType == 1 ||
            (accountType != 1 && foreignRegistered.value)) && (
            <>
              <div className="bg-white shadow-md rounded-md p-4 mt-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    {(accountType == 1 || accountType == 2) && (
                      <div className="">
                        <Dropdown
                          label={
                            <>
                              Registered by ASIC as
                              <span className="text-red-500"> *</span>
                            </>
                          }
                          disabled={companyTypeId.status == "approved"}
                          options={companyTypeData}
                          onSelect={handleSelectCompanyType}
                          preselectedValue={preSelectedCompanyType}
                          parentClass={
                            companyTypeId.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          }
                        />
                      </div>
                    )}
                    {accountType == 3 && (
                      <>
                        {" "}
                        <div className="">
                          <Dropdown
                            label={
                              <>
                                Type Of Company
                                <span className="text-red-500"> *</span>
                              </>
                            }
                            options={companyTypeData}
                            onSelect={handleSelectCompanyType}
                            preselectedValue={preSelectedCompanyType}
                            disabled={companyTypeId.status == "approved"}
                            parentClass={
                              companyTypeId.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            }
                          />
                        </div>
                        <div className="mt-4">
                          <LabelWithStatus
                            id="companyLogo"
                            label={fieldLabelMap.country_of_domicile_id}
                            required={true}
                            fieldData={countryCode}
                            handleStatusClick={handleStatusClick}
                          />
                          <CustomDropdownWithFetch
                            label=""
                            search={true}
                            preselectedValue={preselectedCountryCode}
                            onSelect={handleSelectDomicileCountry}
                            colorLabel=""
                            disabled={countryCode.status == "approved"}
                            fetchOptions={getCountries} // <-- pass fetch function, not options
                            parentClass={
                              countryCode.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            }
                          />
                        </div>
                      </>
                    )}
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.registered_office_address}
                        required={true}
                        fieldData={registeredAddress}
                        handleStatusClick={handleStatusClick}
                      />
                      <AddressAutocomplete
                        value={
                          registeredAddress?.value?.full ||
                          registeredAddressApi?.google_address ||
                          ""
                        }
                        disabled={registeredAddress.status == "approved"}
                        className={
                          registeredAddress.status == "rejected"
                            ? "border-[#FF5050] border-2 w-full"
                            : "w-full"
                        }
                        onSelect={(addr) => {
                          setRegisteredAddressApi(null);
                          setRegisteredAddress({
                            ...registeredAddress,
                            value: addr,
                          });
                        }}
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyLogo"
                        label={fieldLabelMap.principal_place_address}
                        required={true}
                        fieldData={principalAddress}
                        handleStatusClick={handleStatusClick}
                      />
                      <AddressAutocomplete
                        value={
                          principalAddress?.value?.full ||
                          principalAddressApi?.google_address ||
                          ""
                        }
                        className={
                          principalAddress.status == "rejected"
                            ? "border-[#FF5050] border-2 w-full"
                            : "w-full"
                        }
                        disabled={principalAddress.status == "approved"}
                        onSelect={(addr) => {
                          setPrincipalAddressApi(null);
                          setPrincipalAddress({
                            ...principalAddress,
                            value: addr,
                          });
                        }}
                      />
                    </div>
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      Please make sure the provided address matches the document
                      proofs you provide.
                    </p>
                  </div>

                  <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                    {accountType == 1 && (
                      <>
                        <div className="">
                          <LabelWithStatus
                            id="companyLogo"
                            label="State or Territory in Australia in which the Company was formed, incorporated or
                                registered"
                            required={true}
                            fieldData={stateId}
                            handleStatusClick={handleStatusClick}
                          />
                          <Dropdown
                            label=""
                            options={stateData}
                            onSelect={handleSelectStateData}
                            disabled={stateId.status == "approved"}
                            preselectedValue={preselectedStateType}
                            parentClass={
                              stateId.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            }
                          />
                        </div>
                        <div className="mt-4">
                          <LabelWithStatus
                            id="companyLogo"
                            label={fieldLabelMap.abn}
                            required={true}
                            fieldData={abn}
                            handleStatusClick={handleStatusClick}
                          />
                          <input
                            id="abn"
                            name="abn"
                            type="text"
                            value={abn.value}
                            placeholder="Enter ABN"
                            disabled={abn.status == "approved"}
                            className={`${
                              abn.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                            onChange={(e) =>
                              setAbn({
                                ...abn,
                                value: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="mt-4">
                          <LabelWithStatus
                            id="companyLogo"
                            label={fieldLabelMap.acn}
                            required={true}
                            fieldData={acn}
                            handleStatusClick={handleStatusClick}
                          />
                          <input
                            id="acn"
                            name="acn"
                            type="text"
                            value={acn.value}
                            placeholder="Enter ACN"
                            disabled={acn.status == "approved"}
                            className={`${
                              acn.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                            onChange={(e) =>
                              setAcn({
                                ...acn,
                                value: e.target.value,
                              })
                            }
                          />
                        </div>
                      </>
                    )}

                    {accountType == 3 && (
                      <>
                        <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                          <label
                            htmlFor="stockRegistered"
                            className="block whitespace-normal break-words text-sm text-labelColour"
                          >
                            Is your company listed under an Australian
                            Comparable Stock Exchange?
                            <span className="text-red-500">*</span>
                          </label>

                          {/* Radio Buttons */}
                          <div className="flex items-center gap-4">
                            <label className="flex items-center text-sm text-black">
                              <input
                                type="radio"
                                name="stockRegistered"
                                value={true}
                                checked={stockRegistered.value === true}
                                onChange={handleStockRegistered}
                                disabled={stockRegistered.status == "approved"}
                                className={`${
                                  stockRegistered.status == "rejected"
                                    ? "border-[#FF5050] border-2"
                                    : "border-gray-300"
                                } confirm-check w-4 h-4 text-[#005A9C]  focus:ring-[#005A9C]`}
                              />
                              <span className="ml-2">Yes</span>
                            </label>

                            <label className="flex items-center text-sm text-black">
                              <input
                                type="radio"
                                name="stockRegistered"
                                value={false}
                                checked={stockRegistered.value === false}
                                onChange={handleStockRegistered}
                                disabled={stockRegistered.status == "approved"}
                                className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                              />
                              <span className="ml-2">No</span>
                            </label>
                          </div>
                        </div>
                        {stockRegistered.value && (
                          <div className="mt-4">
                            <LabelWithStatus
                              id="companyLogo"
                              label="Select the relevant Stock Exchange"
                              required={true}
                              fieldData={stockExchangeId}
                              handleStatusClick={handleStatusClick}
                            />
                            <Dropdown
                              label=""
                              options={stockExchangeData}
                              disabled={stockExchangeId.status == "approved"}
                              onSelect={handleSelectStockExchange}
                              parentClass={
                                stockExchangeId.status == "rejected"
                                  ? "border-[#FF5050] border-2"
                                  : ""
                              }
                            />
                          </div>
                        )}
                      </>
                    )}
                    {accountType != 1 && (
                      <>
                        <div className="">
                          <LabelWithStatus
                            id="arbn"
                            label="ARBN"
                            required={true}
                            fieldData={arbn}
                            handleStatusClick={handleStatusClick}
                          />
                          <input
                            id="arbn"
                            name="arbn"
                            type="text"
                            value={arbn.value}
                            disabled={arbn.status == "approved"}
                            placeholder="Enter ARBN"
                            className={`${
                              arbn.status == "rejected"
                                ? "border-[#FF5050] border-2"
                                : ""
                            } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                            onChange={(e) =>
                              setArbn({
                                ...arbn,
                                value: e.target.value,
                              })
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                    <div className="">
                      <LabelWithStatus
                        id="companySecretary"
                        label={fieldLabelMap.company_secretary_name}
                        required={true}
                        fieldData={companySecretary}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="companySecretary"
                        name="companySecretary"
                        type="text"
                        value={companySecretary.value}
                        disabled={companySecretary.status == "approved"}
                        placeholder="Enter name.."
                        className={`${
                          companySecretary.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setCompanySecretary({
                            ...companySecretary,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="companyWebsite"
                        label={fieldLabelMap.companyWebsite}
                        required={true}
                        fieldData={companyWebsite}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="companyWebsite"
                        name="companyWebsite"
                        type="text"
                        value={companyWebsite.value}
                        placeholder="Enter link"
                        disabled={companyWebsite.status == "approved"}
                        className={`${
                          companyWebsite.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setCompanyWebsite({
                            ...companyWebsite,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                    {accountType != 1 && formationCountry.value.id == 233 && (
                      <div className="mt-4">
                        <LabelWithStatus
                          id="taxID"
                          label={fieldLabelMap.tax_id}
                          required={true}
                          fieldData={taxId}
                          handleStatusClick={handleStatusClick}
                        />
                        <input
                          id="taxID"
                          name="taxID"
                          type="text"
                          value={taxId.value}
                          placeholder="Enter Number"
                          disabled={taxId.status == "approved" ? true : false}
                          className={`${
                            taxId.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                          onChange={(e) =>
                            setTaxId({
                              ...taxId,
                              value: e.target.value,
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="bg-white shadow-md rounded-md p-4 mb-4 mt-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    <div className="">
                      <LabelWithStatus
                        id="toCurrency"
                        label={fieldLabelMap.default_investment_currency_id}
                        required={true}
                        fieldData={toCurrency}
                        handleStatusClick={handleStatusClick}
                      />
                      <Dropdown
                        label=""
                        options={currencyData}
                        search={true}
                        disabled={toCurrency.status == "approved"}
                        preselectedValue={preselectedcashCurrency}
                        onSelect={handleSelectToCurrency}
                        colorLabel=""
                        parentClass={
                          toCurrency.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        }
                      />
                    </div>
                    <div className="mt-4">
                      <LabelWithStatus
                        id="transactionLevel"
                        label={fieldLabelMap.intended_transaction_behavior}
                        required={true}
                        fieldData={transactionLevel}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="transactionLevel"
                        name="transactionLevel"
                        type="text"
                        value={transactionLevel.value}
                        placeholder="Enter transaction behaviour"
                        disabled={transactionLevel.status == "approved"}
                        className={`${
                          transactionLevel.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setTransactionLevel({
                            ...transactionLevel,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                    <div className="">
                      <LabelWithStatus
                        id="source"
                        label={fieldLabelMap.source_of_funds_origin}
                        required={true}
                        fieldData={source}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="source"
                        name="source"
                        type="text"
                        value={source.value}
                        placeholder="Enter Source"
                        disabled={source.status == "approved"}
                        className={`${
                          source.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setSource({
                            ...source,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                    <div className="">
                      <LabelWithStatus
                        id="investmentAmount"
                        label={fieldLabelMap.expected_investment_amount}
                        required={true}
                        fieldData={investmentAmount}
                        handleStatusClick={handleStatusClick}
                      />
                      <Dropdown
                        label=""
                        options={expectedAmountData}
                        onSelect={handleSelectInvestmentAmount}
                        disabled={investmentAmountText.status == "approved"}
                        preselectedValue={preselectedInevstmentAmount}
                        parentClass={
                          investmentAmountText.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : ""
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {accountType != 1 && (
                <div className="bg-white shadow-md rounded-md p-4 mb-4 mt-4">
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                    <h1 className="text-xl font-medium mb-2">
                      Details of the company's local agent in Australia (if any)
                    </h1>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                      <div className="">
                        <LabelWithStatus
                          id="agentName"
                          label="Full Name"
                          required={true}
                          fieldData={agentName}
                          handleStatusClick={handleStatusClick}
                        />
                        <input
                          id="agentName"
                          name="agentName"
                          type="text"
                          value={agentName.value}
                          placeholder="Enter name"
                          disabled={agentName.status == "approved"}
                          className={`${
                            agentName.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                          onChange={(e) =>
                            setAgentName({
                              ...agentName,
                              value: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="space-y-4 lg:pt-4 pt-0 border-r-0  border-gray-300 px-4 md:pl-0 pr-4">
                      <div className="">
                        <LabelWithStatus
                          id="Address"
                          label="Address"
                          required={true}
                          fieldData={agentAddress}
                          handleStatusClick={handleStatusClick}
                        />
                        <AddressAutocomplete
                          disabled={agentAddress.status == "approved"}
                          value={
                            agentAddress?.value?.full ||
                            agentAddressApi?.google_address ||
                            ""
                          }
                          className={
                            agentAddress.status == "rejected"
                              ? "border-[#FF5050] border-2 w-full"
                              : "w-full"
                          }
                          onSelect={(addr) => {
                            setAgentAddressApi(null);
                            setAgentAddress({
                              ...agentAddress,
                              value: addr,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4"></div>
                  </div>
                </div>
              )}
            </>
          )}
      </div>
      {formationCountry.value &&
        formationCountry.value.risk_factor != "high" &&
        accountType != 1 &&
        !foreignRegistered.value && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
              <button class="absolute top-3 right-3 text-black text-xl font-bold">
                &times;
              </button>

              <div class="flex justify-center items-center mb-4">
                <div class="flex items-center justify-center">
                  <img
                    src="/warning-circle.svg"
                    alt="Add Template Icon"
                    className="h-10 w-10"
                  />
                </div>
              </div>

              <h2 class="text-lg font-medium mb-2">Unable to Proceed</h2>
              <p class="text-sm text-black mb-2">
                We regret to inform you that your company is not eligible to
                register as a corporate customer since it is not currently
                registered under the relevant foreign registration body!
              </p>
              <p class="text-sm text-black mb-4">
                If you accidentally chose "No". Kindly click on “Continue
                Application” and proceed to enter your Tax ID information by
                selecting "Yes".{" "}
              </p>

              <div class="flex justify-center space-x-4">
                <button
                  onClick={() => {
                    navigate("/login");
                  }}
                  class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                >
                  Back To Login
                </button>
                <button
                  onClick={() => {
                    setForeignRegistered({
                      ...foreignRegistered,
                      value: true,
                    });
                  }}
                  class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                >
                  Continue Application
                </button>
              </div>
            </div>
          </div>
        )}
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {formationCountry.value &&
        formationCountry.value.risk_factor != "high" && (
          <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
            {stepStatus.length > 0 &&
              stepStatus[0].status != "COMPLETED" &&
              stepStatus[0].status != "APPROVED" &&
              stepStatus[0].status != "IN_REVIEW" && (
                <>
                  <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
                    <ConfirmResetButton
                      onConfirm={handleReset}
                      isReset={true}
                      isBack={false}
                      onBack={handleBack}
                    />
                  </div>
                  <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                    {/* Save as Draft */}
                    <button
                      onClick={() => {
                        handleContinue(false);
                      }}
                      className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                    >
                      <span>Save as Draft</span>
                    </button>

                    <ConfirmContinueButton
                      onContinue={() => handleContinue(true)}
                      buttonText="Continue"
                      confirmTitle="Save Section"
                      confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                    />
                  </div>
                </>
              )}
            {stepStatus.length > 0 &&
              (stepStatus[0].status == "COMPLETED" ||
                stepStatus[0].status == "APPROVED" ||
                stepStatus[0].status == "IN_REVIEW") && (
                <>
                  <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
                    <ConfirmResetButton
                      onConfirm={handleReset}
                      isReset={false}
                      isBack={true}
                      onBack={handleBack}
                    />
                  </div>
                  <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                    {/* Save as Draft */}
                    <button
                      onClick={() => {
                        setCurrentStep(2);
                      }}
                      className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                    >
                      <span>Next</span>
                    </button>
                  </div>
                </>
              )}
          </footer>
        )}
    </div>
  );
};

export default CorporateInfo;
